import React       from 'react';
import ReactDom    from 'react-dom';

import Const       from 'fw_const';

import ProjectPostContentsModal from '@project/modal/post-contents-modal/_project-post-contents-modal';
// -------------------------------------------------------

class InputPostContents extends React.Component {
  render() {
    let data = this.props.data;
    let base = this.props.base;
    
    let contents = [];
    try { contents = data.default.split(',').filter((t) => { if( t != '' ) return t; }); } catch(e) {}
    
    return (
      <div className="upload-post-contents">
        <div className="upload-post-contents-box">
          { contents.map((id, key) => {
            return <p key={key}>{Const.value.contents_type[id]}</p>;
          })}
          
          { (base.event.showProjectPostContents != undefined) &&
            <p className="edit-post-contents" onClick={base.event.showProjectPostContents.bind(this, data.default)}><i className="material-icons">add</i>編集</p>
          }
        </div>
        
        <ProjectPostContentsModal data={base} update_ev={this.props.update_ev.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputPostContents;